<template>
  <div>
    <div style="padding-bottom: 100px" class="pt-10" v-show="showChart">
      <v-card outlined class="mb-2">
        <v-card-title>{{ $t("overview") }}</v-card-title>
        <v-divider></v-divider>
        <v-row class="align-center">
          <v-col cols="12" sm="6" md="6" class="fill-height d-flex flex-column">
            <v-card class="ma-4" outlined>
              <v-list-item class="pr-2 align-center">
                <v-list-item-icon tile size="80" class="ml-4 mr-8">
                  <v-icon x-large color="rgba(21, 101, 192, 1)">
                    mdi-ticket-confirmation
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                    R$
                    {{
                      data.bet_value
                        ? data.bet_value.split(".").join(",")
                        : "0,00"
                    }}
                  </v-list-item-title>
                  <div class="mb-4">
                    {{ $t("bets") }}
                  </div>
                </v-list-item-content>
                <v-list-item-avatar
                  tile
                  size="80"
                  color="rgba(30, 30, 30, 0)"
                  class="ml-0"
                >
                  <v-progress-circular
                    :value="100"
                    size="60"
                    color="rgba(21, 101, 192, 1)"
                  >
                    {{ 100 }}%
                  </v-progress-circular>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
            <v-card class="ma-4" outlined>
              <v-list-item class="pr-2">
                <v-list-item-icon tile size="80" class="ml-4 mr-8">
                  <v-icon x-large color="rgba(242, 167, 36, 1)">
                    mdi-ticket-confirmation
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                    R$
                    {{
                      data.prize_value
                        ? data.prize_value.split(".").join(",")
                        : "0,00"
                    }}
                  </v-list-item-title>
                  <div class="mb-4">
                    {{ $t("awarded") }}
                  </div>
                </v-list-item-content>
                <v-list-item-avatar
                  tile
                  size="80"
                  color="rgba(30, 30, 30, 0)"
                  class="ml-0"
                >
                  <v-progress-circular
                    :value="awardedBetPercentage"
                    size="60"
                    color="rgba(242, 167, 36, 1)"
                  >
                    {{ awardedBetPercentage }}%
                  </v-progress-circular>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
            <v-card class="ma-4" outlined>
              <v-list-item class="pr-2">
                <v-list-item-icon tile size="80" class="ml-4 mr-8">
                  <v-icon
                    x-large
                    :color="
                      data.ggr >= 0
                        ? 'rgba(71, 126, 50, 1)'
                        : 'rgba(216, 67, 21, 1)'
                    "
                  >
                    mdi-cash-multiple
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                    <div v-if="data.ggr > 0">
                      <!-- GGR Positivo -->
                      R$
                      {{
                        data.ggr
                          ? data.ggr
                              .toString()
                              .split(".")
                              .join(",")
                          : "0,00"
                      }}
                    </div>
                    <div v-else-if="data.ggr < 0">
                      {{
                        data.ggr
                          ? data.ggr
                              .toString()
                              .split("-")
                              .join("-R$ ")
                              .split(".")
                              .join(",")
                          : "0,00"
                      }}
                    </div>
                    <div v-else>R$ 0,00</div>
                  </v-list-item-title>
                  <div class="mb-4">GGR</div>
                </v-list-item-content>
                <v-list-item-avatar
                  tile
                  size="80"
                  color="rgba(30, 30, 30, 0)"
                  class="ml-0"
                >
                  <v-progress-circular
                    :value="ggrBetPercentage"
                    size="60"
                    :color="
                      data.ggr >= 0
                        ? 'rgba(71, 126, 50, 1)'
                        : 'rgba(216, 67, 21, 1)'
                    "
                  >
                    {{ ggrBetPercentage }}%
                  </v-progress-circular>
                </v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <GeneralHorizontalBar
              class="pa-4"
              :data="chartData"
              :propOptions="chartOptions"
            />
          </v-col>
        </v-row>
      </v-card>

      <div
        class="d-flex justify-space-between"
        :class="
          $vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row flex-wrap'
        "
        style="margin: 0px -8px 0px -8px"
      >
        <div class="ma-2" style="flex-basis: 25%; flex-grow: 1; flex-shrink: 1">
          <v-card outlined class="fill-height">
            <v-list-item>
              <v-list-item-icon tile size="80" class="ml-4 mr-8">
                <v-icon x-large color="rgba(21, 101, 192, 1)">
                  mdi-ticket-confirmation-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                  {{ data.total_bets }}
                </v-list-item-title>
                <div class="mb-4">
                  {{ $t("betsAmount") }}
                </div>
              </v-list-item-content>
              <v-list-item-action-text class="primary--text">
                <v-progress-circular
                  :value="100"
                  size="40"
                  color="rgba(21, 101, 192, 1)"
                >
                  {{ 100 }}%
                </v-progress-circular>
              </v-list-item-action-text>
            </v-list-item>
          </v-card>
        </div>
        <div class="ma-2" style="flex-basis: 25%; flex-grow: 1; flex-shrink: 1">
          <v-card outlined class="fill-height">
            <v-list-item>
              <v-list-item-icon tile size="80" class="ml-4 mr-8">
                <v-icon x-large color="rgba(242, 167, 36, 1)">
                  mdi-ticket-confirmation-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                  {{ data.prize_qtd }}
                </v-list-item-title>
                <div class="mb-4">
                  {{ $t("amountAwarded") }}
                </div>
              </v-list-item-content>
              <v-list-item-action-text>
                <v-progress-circular
                  :value="awardedQtdPercentage"
                  size="40"
                  color="rgba(242, 167, 36, 1)"
                >
                  {{ awardedQtdPercentage }}%
                </v-progress-circular>
              </v-list-item-action-text>
            </v-list-item>
          </v-card>
        </div>
        <div class="ma-2" style="flex-basis: 25%; flex-grow: 1; flex-shrink: 1">
          <v-card outlined class="fill-height">
            <v-list-item>
              <v-list-item-icon tile size="80" class="ml-4 mr-8">
                <v-icon x-large color="rgba(216, 67, 21, 1)">
                  mdi-ticket-confirmation-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                  {{ data.loss_qtd }}
                </v-list-item-title>
                <div class="mb-4">
                  {{ $t("AmountLostBets") }}
                </div>
              </v-list-item-content>
              <v-list-item-action-text class="primary--text">
                <v-progress-circular
                  :value="lossQtdPercentage"
                  size="40"
                  color="rgba(216, 67, 21, 1)"
                >
                  {{ lossQtdPercentage }}%
                </v-progress-circular>
              </v-list-item-action-text>
            </v-list-item>
          </v-card>
        </div>
        <div class="ma-2" style="flex-basis: 25%; flex-grow: 1; flex-shrink: 1">
          <v-card outlined class="fill-height">
            <v-list-item>
              <v-list-item-icon tile size="80" class="ml-4 mr-8">
                <v-icon
                  x-large
                  :color="$vuetify.theme.dark ? 'grey darken-1' : 'black'"
                >
                  mdi-clock-outline
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                  {{ data.pendent_qtd }}
                </v-list-item-title>
                <div class="mb-4">
                  {{ $t("amountPending") }}
                </div>
              </v-list-item-content>
              <v-list-item-action-text class="primary--text">
                <v-progress-circular
                  :value="pendentQtdPercentage"
                  size="40"
                  :color="$vuetify.theme.dark ? 'grey darken-1' : 'black'"
                >
                  {{ pendentQtdPercentage }}%
                </v-progress-circular>
              </v-list-item-action-text>
            </v-list-item>
          </v-card>
        </div>
        <div class="ma-2" style="flex-basis: 25%; flex-grow: 1; flex-shrink: 1">
          <v-card outlined class="fill-height">
            <v-list-item>
              <v-list-item-icon tile size="80" class="ml-4 mr-8">
                <v-icon
                  x-large
                  :color="$vuetify.theme.dark ? 'grey darken-1' : 'black'"
                >
                  mdi-cash-multiple
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1 mt-3 font-weight-bold">
                  R$
                  {{
                    data.pendent_value
                      ? data.pendent_value.split(".").join(",")
                      : "0,00"
                  }}
                </v-list-item-title>
                <div class="mb-4">
                  {{ $t("pendings") }}
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </div>
      </div>
    </div>
    <div class="text-center">
      <h3 v-show="!showChart">
        {{ $t("noDataForthisQuery") }}
      </h3>
    </div>
  </div>
</template>
<script>
import GeneralHorizontalBar from "@/components/Charts/GeneralHorizontalBar";

export default {
  name: "collaborator-dashboard-home",
  components: {
    GeneralHorizontalBar,
  },
  data: () => ({
    data: {},
    date_start: "",
    data_final: "",
    showChart: true,
    betsDescription: "",
  }),
  mounted() {
    // this.$store.commit("SetRangeSelect", {
    //   label: this.$t("lastSevenDays"),
    //   value: "lastSevenDays",
    // });

    this.getData();
  },
  computed: {
    awardedBetPercentage() {
      return Number(this.data.bet_value) != 0
        ? Math.round(
            (Number(this.data.prize_value) / Number(this.data.bet_value)) * 100
          )
        : 0;
    },
    ggrBetPercentage() {
      return Number(this.data.bet_value) != 0
        ? Math.round(
            (Number(this.data.ggr) / Number(this.data.bet_value)) * 100
          )
        : 0;
    },
    pendentQtdPercentage() {
      return Math.round((this.data.pendent_qtd / this.data.total_bets) * 100);
    },
    lossQtdPercentage() {
      return Math.round((this.data.loss_qtd / this.data.total_bets) * 100);
    },
    awardedQtdPercentage() {
      return Math.round((this.data.prize_qtd / this.data.total_bets) * 100);
    },

    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    rangeDateUI() {
      return this.$store.state.rangeUI;
    },
    // Recuperando o Select
    // selectDate() {
    //   // console.log("Computed: selectDate");
    //   return this.$store.state.range.select;
    // },
    type() {
      return this.$store.state.filters.selectTypeBet.type;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => "R$ " + value,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem) =>
              tooltipItem.yLabel +
              ": R$ " +
              Number(tooltipItem.value)
                .toFixed(2)
                .split(".")
                .join(","),
          },
        },
      };
    },
    chartData() {
      // Labels
      let isGGRNegative = this.data.ggr < 0;
      let chartData = {
        labels: [this.$t("bets"), this.$t("awarded"), "GGR"],
        datasets: [
          {
            label: this.$t("bets"),
            data: [
              this.data.bet_value,
              Number(this.data.prize_value),
              this.data.ggr,
            ],
            fill: false,
            maxBarThickness: 50,
            backgroundColor: [
              "rgba(21, 101, 192, 1)",
              "rgba(249, 168, 37, 1)",
              isGGRNegative ? "rgba(216, 67, 21, 1)" : "rgba(46, 125, 50, 1)",
            ],
            borderColor: [
              "rgba(0, 60, 143, 1)",
              "rgba(193, 121, 0, 1)",
              isGGRNegative ? "rgba(159, 0, 0, 1)" : "rgba(0, 80, 5, 1)",
            ],
          },
        ],
      };
      return chartData;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getData();
    },
  },
  methods: {
    async getData() {
      const body = {
        ...this.rangeDate,
        bets_type: this.type,
      };

      await this.$request
        .post("/colab/report/betsReportOnline", body)
        .then((response) => {
          this.data = response.dados;
          // this.data = {
          //   ...this.data,
          //   bet_value: "1000.60",
          //   prize_value: "200.40",
          //   pendent_value: "6.00",
          //   prize_qtd: "5",
          //   pendent_qtd: "3",
          //   loss_qtd: "10",
          // };

          this.showChart = this.data.bet_value ? true : false;
          this.date_start = new Date(body.data_inicio.replace(" ", "T"))
            .toLocaleString()
            .slice(0, -9);

          this.data_final = new Date(body.data_final.replace(" ", "T"))
            .toLocaleString()
            .slice(0, -9);

          this.data.ggr = Number(
            Number(this.data.bet_value).toFixed(2) -
              Number(this.data.prize_value).toFixed(2)
          ).toFixed(2);

          this.data.total_bets =
            Number(this.data.loss_qtd) +
            Number(this.data.prize_qtd) +
            Number(this.data.pendent_qtd);

          this.betsDescription =
            this.type === "deposit"
              ? this.$t("betsWithDeposit")
              : this.$t("betsWithBonus");
        })
        .catch((error) => {
          console.log(error);
          this.betsDescription = "";
        });
    },
  },
};
</script>
